import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../services/modal.service';

@Component({
    selector: 'app-ai-chat-trigger',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ai-chat-trigger.html',
    styleUrls: ['./ai-chat-trigger.scss']
})
export class AiChatTriggerComponent {
    constructor(private modalService: ModalService) { }

    openChat() {
        // Check if dashboard is in edit mode by looking for the global class
        if (document.body.classList.contains('edit-mode')) {
            return;
        }

        this.modalService.openAiAdviceModal();
    }
}
